import { LabMDM } from "../masterdata/models/lab";

export class Primer {
    _id: string
    materialType: string
    creationDate: number
    lastModifiedDate: number
    version: number
    type: string
    barcode: string
    originalVolume: number
    remainingVolume: number
    orderItemId: string
    container: string
    lab: LabMDM
    primerName: string

    constructor() {
        this.type = 'Primer'
    }
}